import { useEffect } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import Layout from './components/common/Layout'
import About from './pages/about'
import Contact from './pages/contact'
import Custom from './pages/custom'
import Gallery from './pages/gallery'
import Landing from './pages/landing'

function App() {

  useEffect(() => {
    // Suppress ResizeObserver error - this is a harmless browser timing issue
    const handleError = (event) => {
      if (event.message === 'ResizeObserver loop completed with undelivered notifications.') {
        event.stopImmediatePropagation()
        event.preventDefault()
        return false
      }
    }

    window.addEventListener('error', handleError)
    
    // Also handle unhandled promise rejections that might contain this error
    const handleUnhandledRejection = (event) => {
      if (event.reason && event.reason.message &&
          event.reason.message.includes('ResizeObserver loop completed')) {
        event.preventDefault()
        return false
      }
    }

    window.addEventListener('unhandledrejection', handleUnhandledRejection)

    return () => {
      window.removeEventListener('error', handleError)
      window.removeEventListener('unhandledrejection', handleUnhandledRejection)
    }
  }, [])

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout><Landing /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/custom" element={<Layout><Custom /></Layout>} />
        <Route path="/gallery" element={<Layout><Gallery/></Layout>} />
      </Routes>
    </Router>
  )
}

export default App
